import { render } from "./PlayerPrivateChat.vue?vue&type=template&id=e1fa93b4&scoped=true&ts=true"
import script from "./PlayerPrivateChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerPrivateChat.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerPrivateChat.vue?vue&type=style&index=0&id=e1fa93b4&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1fa93b4"],['__file',"src/views/player/PlayerPrivateChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1fa93b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1fa93b4', __exports__)) {
    console.log('reload')
    api.reload('e1fa93b4', __exports__)
  }
  
  module.hot.accept("./PlayerPrivateChat.vue?vue&type=template&id=e1fa93b4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('e1fa93b4', render)
  })

}


export default __exports__